/**
 * Exhibition app entry point.
 *
 * Imports the core primitive registrations and each Phase 1 panel module
 * as side-effect imports so every custom element is defined before the
 * top-level `<exhibition-app>` mounts. Routing then decides which panel
 * actually renders.
 */

import '@pedestal-panels/core';

import '@pedestal-panels/panel-rcp-3500';
import '@pedestal-panels/panel-msu-3000';
import '@pedestal-panels/panel-mcp-400';
import '@pedestal-panels/panel-ocp-400';
import '@pedestal-panels/panel-cgp-500';

import './components/exhibition-app.ts';

// Default to the CGP-500 view on a cold load — it is the most visually
// informative panel in the catalogue and the natural showcase entry.
if (!window.location.hash) {
  window.location.hash = '#/panels/grassvalley/cgp-500';
}
